export const channel = {
    "ershoufang":"二手房",
    "xinfang":"新房",
    "zufang":"租房",
    "shangyedichan":"商业地产",
    "zixun":"资讯",
    "xinzixun":"新资讯",
    "wenda":"问答",
    "gujia":"估价",
    "xuexiaozhaofang":"学校找房",
    "xiaoqu":"小区",
    "zhuantituijian":"专题推荐",
    "baike":"百科",
    "goufangzige":"购房资格",
    "goufangweituo":"购房委托",
    "shangyebangong":"商业办公",
    "haiwai":"海外",
    "fangjia":"房价",

    "shouye":"首页",
    "huiyuanzhongxin":"会员中心",
    "jingjiren":"经纪人",
    "zhuanti":"专题",
    "denglu":"登录",
    "ershoufangliebiao":"二手房列表",
    "jubao":"举报",
    "jingjirenzhongxin":"经纪人中心",
    "qita":"其它",
    "xiezilou":"写字楼",
    "weituo":"委托",
    "shangpu":"商铺",
    "520tuangoujie":"520团购节",
    "weiliao":"微聊",
    "zixun1":"咨询"
}